import React, { useState } from 'react'

export const Payment: React.FC = () => {
	const [haveVATNumber, setHaveVATNumber] = useState<boolean>(false)
	return (
		<div className='component-content'>
			<h1>Payment Details</h1>
			<p>
				You won’t be charged during your trial period.
				<h4> We promise.</h4>
			</p>
			<input type='text' placeholder='Company Name (Optional)' />
			<input type='text' placeholder='Card Holder Full Name *' />
			<section className='card-number-requirements'>
				<input type='text' placeholder='Card Number *' />
				<input type='text' placeholder='MM / YY   CVC' />
			</section>
			<p>
				<h3 onClick={() => setHaveVATNumber(!haveVATNumber)}>
					{haveVATNumber ? "No, I don't have VAT Number" : 'I have VAT Number'}
				</h3>
			</p>
			{haveVATNumber && <input type='text' placeholder='Enter Vat Number' />}
			<p>
				By registering you agree to the
				<span>
					<b> Terms of Use</b>
				</span>
			</p>
			<button>log in</button>
		</div>
	)
}
